import { type CancelToken } from 'axios';
import { apiPost } from '~/_shared/utils/api/api.helpers';

//this can be either an entry from DeWmsDemographicCategory or a column id in the format column_X
export type ConstraintsMetric = string;

export type ValidateWMSTerritoryConstraintsItem = {
  metric: string;
  min: number;
  max: number;
};

export type ValidateWMSTerritoryConstraintsRequest = {
  map_id: number;
  spreadsheet_id: number;
  constraints: ValidateWMSTerritoryConstraintsItem[];
  dataset_states?: ReadonlyArray<string>;
  dataset_zip_codes?: ReadonlyArray<string>;
};

export type ValidateTerritoryConstraintResultItem = {
  limits: {
    lowestMax: number | null;
    highestMin: number | null;
    min: number;
    max: number;
  };
  value: {
    min: number;
    max: number;
  };
  errors: string[];
  isValid: boolean;
};

export type ValidateWMSTerritoryConstraintResultItem = ValidateTerritoryConstraintResultItem & {
  metric: ConstraintsMetric;
};

type ValidateWMSTerritoryConstraintsResponse = {
  results: ValidateWMSTerritoryConstraintResultItem[];
};

export const validateWMSTerritoryConstraints = (
  clientId: number, params: ValidateWMSTerritoryConstraintsRequest, cancelToken?: CancelToken
): Promise<ValidateWMSTerritoryConstraintsResponse> => {
  const requestUrl = `/api/clients/${clientId}/optimized-territories/constraints`;

  return apiPost(requestUrl, params, {
    cancelToken,
  });
};
